import { useMemo } from 'react';
import { useIsColumnVisible } from '~/state/tableColumns';
import { isToggleableColumn, type TableColumnVisibilityConfig } from './ColumnConfig';

/**
 * Applies contextual and user-controlled visibility while keeping row-header
 * and non-toggleable columns in the table.
 */
export const useVisibleColumns = <T extends TableColumnVisibilityConfig>(columns: readonly T[]): T[] => {
  const isColumnVisible = useIsColumnVisible();

  return useMemo(
    () => columns.filter((column) => !column.isHidden && (!isToggleableColumn(column) || isColumnVisible(column.id))),
    [columns, isColumnVisible],
  );
};
